
/* eslint-disable object-curly-newline */
/* global FormData */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withMessage from '../../withMessage.jsx';
import FileTransferRequests from '../../../../../components/file-transfer/utils/FileTransferRequests.js';
import { composeClassName } from '../../utils/common.js';
import { MessageTypes } from '../../constants/index.js';
import CloseButton from '../../../../../components/chat-tools/CloseButton.jsx';
import RetryButton from '../../../../../components/chat-tools/RetryButton.jsx';
import RepickFileButton from '../../../../../components/chat-tools/RepickFileButton.jsx';
import { ErrorIcon } from '../../../../../components/icons'

class FileMessage extends Component {
  MAX_FILE_SIZE = 100 * 1024 * 1024; /* 100MB */

  static defaultProps = {
    onRemove: () => {},
    onRepick: () => {},
  }

  state = {
    uploaded: 0,
    result: null,
    request: null,
    error: {
      retryButtonEnabled: false,
      repickButtonEnabled: false,
      message: '',
    },
  }

  componentDidMount() {
    const { submitExtraParams } = this.props;
    if (submitExtraParams.progressSubmitParams.fileTransferSessionId) {
      this.sendFile();
    }
  }

  componentDidUpdate(prevProps) {
    const { additionalState, submitExtraParams } = this.props;
    const { additionalState: prevAdditionalState, submitExtraParams: prevSubmitExtraParams } = prevProps;
    if (prevAdditionalState.file !== additionalState.file) {
      this.sendFile();
      return;
    }

    if (!prevSubmitExtraParams.progressSubmitParams.fileTransferSessionId
        && submitExtraParams.progressSubmitParams.fileTransferSessionId) {
      this.sendFile();
    }
  }

  componentWillUnmount() {
    const { request } = this.state;

    if (request) {
      request.unsubscribe();
    }
  }

  setError = (message, retryButtonEnabled, repickButtonEnabled) => {
    this.setState({
      error: {
        message,
        retryButtonEnabled,
        repickButtonEnabled,
      },
    });
  }

  handleProgressChange = (size, uploaded) => {
    this.setState({ size, uploaded: Number(uploaded) });
  }

  finishLoading = result => {
    const { textProps } = this.props;

    if (!result) {
      this.setError(textProps.failedText, true, false);
      return;
    }

    this.setState({ result });
  }

  handleRepickFile = event => {
    const { files } = event.target;
    const { onRepick, additionalState } = this.props;
    const { filename } = additionalState;
    this.setState({ file: files[0], error: { message: '' } });

    onRepick(filename, files[0]);
  }

  handleCancel = () => {
    const { request } = this.state;
    const { onRemove } = this.props;

    if (request) {
      request.abort();
    }

    onRemove();
  }

  sendFile = () => {
    const { additionalState, textProps } = this.props;
    const { file } = additionalState;

    if (!file.name) {
      this.setError(textProps.sendFileInterrupted, false, true);
      return;
    }

    if (file.size > this.MAX_FILE_SIZE) {
      this.setError(textProps.sizeExceeded, false, false);
      return;
    }

    const request = this.createFileRequest(file);
    this.setState({ request });
  }

  createFileRequest = file => {
    const { nickname, submitExtraParams } = this.props;

    const formData = new FormData();
    formData.append('nickname', nickname);
    formData.append('sent_file', file);

    return new FileTransferRequests({
      sendFileParams: formData,
      progressLoadedParams: submitExtraParams.progressSubmitParams,
      actionUrl: submitExtraParams.actionUrl,
      onStartLoading: () => {},
      onEndLoading: this.finishLoading,
      onSetLoadStatus: this.handleProgressChange,
      onError: this.handleCancel,
    });
  }

  render() {
    const {
      textProps,
      nickname,
      messageTime,
      isFirstInGroup,
      isLastInGroup,
      additionalState,
    } = this.props;
    const { file } = additionalState;

    const { uploaded, error } = this.state;

    const fsize = (file.size / (1024 * 1024)).toFixed(2);
    const transferredText = `${file.name}: ${textProps.transferred} ${uploaded}MB / ${fsize}MB.`;
    const className = composeClassName(MessageTypes.VISITOR, isFirstInGroup, isLastInGroup);

    return (
      <div className={`${className}`}>
        {
          isFirstInGroup
          && (
            <>
              <p className="author">
                {nickname}
              </p>
              {messageTime}
            </>
          )
        }

        <div className="file-upload-message message-text">

          <div className="file-message-content">

            <div className="file-upload-text">
              { error.message ? (
                <div className="file-error">
                  <ErrorIcon />
                  {error.message}
                </div>
              ) : <span>{transferredText}</span>}
            </div>

            <div className="buttons">
              {
                error.retryButtonEnabled
                && (
                <RetryButton
                  onClick={() => this.sendFile(file)}
                  text={error.message}
                />
                )
              }
              {
                error.repickButtonEnabled
                && (
                  <RepickFileButton
                    onChange={this.handleRepickFile}
                    text={error.message}
                  />
                )
              }
              <CloseButton
                onCloseTool={this.handleCancel}
                closeButtonText={textProps.cancel || ''}
              />
            </div>

          </div>

          <div className="progress-wrapper">
            <span className="progress-bar" style={{ width: `${uploaded / fsize * 100}%` }} />
          </div>

        </div>

      </div>
    );
  }
}

if (process.env.NODE_ENV !== 'production') {
  FileMessage.propTypes = {
    nickname: PropTypes.string.isRequired,
    isFirstInGroup: PropTypes.bool.isRequired,
    isLastInGroup: PropTypes.bool.isRequired,
    submitExtraParams: PropTypes.object,
    messageTime: PropTypes.node,
    onRemove: PropTypes.func,
    onRepick: PropTypes.func,
    isFake: PropTypes.bool,
    type: PropTypes.string,
    textProps: PropTypes.object,
    id: PropTypes.string,
    additionalState: PropTypes.shape({
      file: PropTypes.object,
      filename: PropTypes.string,
    }).isRequired,
  };
}

export default withMessage(FileMessage);
